import { Injectable } from '@angular/core';

import { ModulesService } from '../modules/modules/services/modules.service';
import { ReferenceCategoryService } from '../modules/references/services';
import { PersonalizationService } from '../pages/personalization/services/personalization.service';

@Injectable({ providedIn: 'root' })
export class AfterLoginService {
  constructor(
    private personalizationService: PersonalizationService,
    private referenceCategoryService: ReferenceCategoryService,
    private modulesService: ModulesService
  ) {}

  do() {
    this.personalizationService.getPersonalizationData().subscribe();
    this.referenceCategoryService.getAllReferenceCategories();
    this.modulesService.getAllModules().subscribe();
  }
}
